import script from "./CamPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CamPage.vue?vue&type=script&setup=true&lang=js"

import "./CamPage.vue?vue&type=style&index=0&id=20ab0191&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20ab0191"]])

export default __exports__